import { Eyebrow } from "./Eyebrow";

const SELOS = [
  { value: "10 anos", label: "de mercado" },
  { value: "+60 mil", label: "clientes ativos" },
  { value: "+230", label: "colaboradores" },
  { value: "100%", label: "adimplência" },
];

export const ParceirosSobreAllu = () => {
  return (
    <section className="bg-[#FAF8F5] py-16 sm:py-20 md:py-24">
      <div className="container-wide">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Coluna esquerda: copy */}
          <div className="lg:col-span-7">
            <div>
              <Eyebrow className="mb-4">Quem é a Allu</Eyebrow>
              <h2
                className="font-bold leading-[1.1] tracking-tight text-[#323F4F] text-3xl sm:text-4xl md:text-5xl mt-6"
                style={{
                  fontFamily:
                    '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                  letterSpacing: "-0.02em",
                }}
              >
                Uma operação real,{" "}
                <span className="text-[#2E694D]">construída em 10 anos</span>.
              </h2>

              <div className="mt-7 sm:mt-9 space-y-5 text-base sm:text-lg text-zinc-600 leading-relaxed">
                <p>
                  A Allu é a 3ª maior empresa do mundo no aluguel de eletrônicos
                  por assinatura. São 10 anos de mercado, mais de 60 mil
                  clientes ativos, mais de 230 colaboradores e uma lista de
                  espera de mais de 1,7 milhão de pessoas.
                </p>
                <p>
                  O retorno do investidor não vem de promessa. Vem da operação:
                  a Allu compra eletrônicos, aluga em ciclos de assinatura e
                  revende ao final — faturando múltiplas vezes o valor de cada
                  ativo ao longo do ciclo. É lastro real, em produto físico, com
                  demanda mensurável.
                </p>
                <p>
                  <strong className="text-[#323F4F] font-semibold">
                    100% de adimplência desde o início.
                  </strong>{" "}
                  As debêntures são emitidas pela Companhia Securitizadora Allu
                  Invest S.A., reguladas pela CVM e divulgadas pela Dexcap
                  Investimentos (CVM 88) — a mesma estrutura usada por outras
                  operações de securitização privada no mercado brasileiro.
                </p>
              </div>
            </div>
          </div>

          {/* Coluna direita: selos verticais */}
          <div className="lg:col-span-5">
            <div>
              <div className="bg-[#F8F8F7] border border-zinc-200 rounded-3xl p-6 sm:p-8 divide-y divide-zinc-200">
                {SELOS.map((s) => (
                  <div
                    key={s.label}
                    className="py-5 first:pt-0 last:pb-0 flex items-baseline justify-between gap-4"
                  >
                    <div
                      className="text-2xl sm:text-3xl font-bold text-[#323F4F]"
                      style={{
                        fontFamily:
                          '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                        letterSpacing: "-0.02em",
                      }}
                    >
                      {s.value}
                    </div>
                    <div className="text-sm text-zinc-600 text-right">
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
